import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import Utilities from "../../../../lib/Utilities";
import CodeList from "../../../../lib/CodeList";
import Oceanlook from "../../../../lib/oceanlook";
import LogoSvg from "../../../../assets/LogoSvg";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

const util = new Utilities();
const codeList = new CodeList();
const oceanlook = new Oceanlook();

export default function ScheduleLCLTable(props) {
  const {
    page,
    consolidatorList,
    schedule_list,
    loginInfo,
    openCostModal,
    handleChangePage,
    copyScheduleURL,
    insertUserLog,
  } = props;

  const { t } = useTranslation();

  useEffect(() => {
    function changeSchedulePage() {
      //데이터 불러오기
      const scrollTop = document.documentElement.scrollTop; // 현재 스크롤 위치
      const maxScroll =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight; // 최대 스크롤 가능한 높이
      if (maxScroll - scrollTop < 300) {
        handleChangePage(page + 1);
      }
    }

    window.addEventListener("scroll", changeSchedulePage);
    return () => {
      window.removeEventListener("scroll", changeSchedulePage);
    };
  }, [page]);

  function requestEnquiry(item, enquiryType) {
    let typeText = t("schedule.operations");
    if (enquiryType === 1) {
      typeText = t("schedule.sales");
    }
    codeList.Modal.current.confirm(
      `[${item.sm_ORIGIN}-${item.sm_DEST}] ` +
        t("schedule.msg.contactSchedule") +
        ` (${typeText} ${t("schedule.manager")})`,
      (ret) => {
        if (ret) {
          if (!loginInfo) {
            codeList.Modal.current.alert(t("schedule.msg.requiresLogin"));
            return;
          }
          localStorage.setItem("enquiryManager", "Z0001|hskim@gbts.co.kr");
          window.open("/LogiTalk", "LogiTalk", "_blank");
        }
      }
    );
  }

  const data = React.useMemo(() => {
    return [...schedule_list];
  }, [schedule_list]);

  //스케줄 아이템 랜더
  const ScheduleItemRender = useCallback((props) => {
    return <ScheduleItem {...props} />;
  }, []);

  return (
    <>
      <div className="d-none d-xl-block">
        <div className="row m-0 mb-2 p-0 bg-secondary text-white rounded shadow-sm overflow-hidden">
          <div className="col-1 px-1 py-1 m-0 align-items-end">
            {t("schedule.scheduleNo")}
          </div>
          <div className="col-2 px-1 py-1 m-0">
            {t("schedule.consolidator")}
          </div>
          <div className="col-2 px-1 py-1 m-0">
            {t("schedule.docClose")}/{t("schedule.cargoClose")}
          </div>
          <div className="col-4 px-1 py-1 m-0">
            {t("schedule.departure")}/{t("schedule.arrival")}
          </div>
          <div className="col-1 px-1 py-1 m-0">{t("schedule.vessel")}</div>
          <div className="col-2 px-0 m-0 bg-dark text-center d-flex flex-row justify-content-around">
            <div className="px-2 py-1">{t("schedule.info")}</div>
            <div className="px-2 py-1">{t("schedule.rate")}</div>
            <div className="px-2 py-1">{t("schedule.inquiry")}</div>
            <div className="px-2 py-1">{t("schedule.tracking")}</div>
          </div>
        </div>
      </div>
      <div className="row m-0 p-0">
        {data.length === 0 && (
          <div className="col-12 m-0 p-5 bg-white text-center rounded-bottom">
            <p className="h6 mb-0 font-weight-bold text-secondary">
              <i className="fa-regular fa-calendar-days mr-2" />
              {t("schedule.msg.noSchedule")}
            </p>
          </div>
        )}

        {data.length > 0 &&
          data.map((item, index) => {
            return (
              <ScheduleItemRender
                key={item.sm_IDX}
                index={index}
                item={item}
                consolidatorList={consolidatorList}
                insertUserLog={insertUserLog}
                requestEnquiry={requestEnquiry}
                copyScheduleURL={copyScheduleURL}
                openCostModal={openCostModal}
                loginInfo={loginInfo}
              />
            );
          })}
      </div>
    </>
  );
}

const ScheduleItem = React.memo((props) => {
  const {
    item,
    consolidatorList,
    openCostModal,
    insertUserLog,
    requestEnquiry,
    copyScheduleURL,
    loginInfo,
  } = props;

  const { t } = useTranslation();

  const sm_DOC_CLOSE_day = util.handleGetDate(item.sm_DOC_CLOSE);
  const sm_CARGO_CLOSE_day = util.handleGetDate(item.sm_CARGO_CLOSE);
  const sm_DEPARTURE_DATE_day = util.handleGetDate(item.sm_DEPARTURE_DATE);
  const sm_ARRIVE_DATE_day = util.handleGetDate(item.sm_ARRIVE_DATE);

  useEffect(() => {
    $(".open_sch_info_" + item.sm_IDX).on("click", function () {
      document.querySelector("#collapse_btn_" + item.sm_IDX).click();
    });
  }, []);

  let comp_logo = "";
  if (item.COMP_LOGO) {
    comp_logo = item.COMP_LOGO.split("?")[0];
  } else {
    comp_logo = consolidatorList
      .find((data) => data.blFWDNO === item.sm_FWD_NO)
      ?.blLOGO?.split("?")[0];
  }

  const isAbleShipTracking =
    oceanlook.getMMSI(item.sm_VESSEL) || oceanlook.getIMO(item.sm_VESSEL);

  return (
    <div className="col-12 m-0 mb-1 p-0 text-secondary rounded shadow-sm bg-white">
      <div className="row m-0 p-0 p-xl-1 align-items-center font-size-09 cursor_pointer cursor_pointer_bg_light rounded">
        <div className="col-12 col-xl-1 order-0 order-xl-0 m-0 p-0 px-2">
          <div
            className="d-flex flex-row align-items-center py-2 py-xl-0"
            onClick={(e) => {
              copyScheduleURL(item);
              insertUserLog(item, "share", 1);
            }}
          >
            <span className="h6 mr-1 mb-0">
              <i className="fa-solid fa-share-nodes mr-1 text-primary" />
            </span>
            <span className="font-size-09">{item.sm_UID}</span>
          </div>
        </div>
        <div className="col-12 d-xl-none border-bottom" />
        <div
          className={`col-6 col-xl-2 m-0 p-2 p-xl-0 order-1 order-xl-1 open_sch_info_${item.sm_IDX}`}
        >
          <div className="d-flex flex-row align-items-center">
            {comp_logo ? (
              <div
                style={{
                  backgroundImage: `url('${comp_logo}')`,
                  backgroundPosition: "50% 50%",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",

                  width: "40px",
                  height: "40px",
                }}
              />
            ) : (
              <LogoSvg width={"20px"} />
            )}

            <div className="ml-2">
              {item.sm_PROMO_YN === "Y" && (
                <span className="badge badge-danger text-white mr-1 hover_point">
                  PROMO
                  <div
                    className="position-absolute bg-white border shadow-sm p-2 rounded text-center font-weight-bold"
                    style={{
                      minWidth: 180,
                      bottom: "calc(100% + 20px)",
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 9,
                    }}
                  >
                    <p className="text-danger" style={{ fontSize: "1em" }}>
                      *{item.sm_PROMO_MEMO}
                    </p>
                    <div
                      className="bg-white border-right border-bottom"
                      style={{
                        transform: "rotate(45deg)",
                        marginLeft: -10,
                        width: 20,
                        height: 20,
                        position: "absolute",
                        left: "50%",
                      }}
                    />
                  </div>
                </span>
              )}
              {util.isNumber(item.sm_IDX) && (
                <span className="badge badge-info">
                  {t("schedule.suggested")}
                </span>
              )}
              <p className="font-weight-bold mt-1">
                {item.COMP_NM || item.sm_FWD_NM}
              </p>
            </div>
          </div>
        </div>
        <div
          className={`col-12 col-xl-2 m-0 px-1 p-xl-0 order-3 order-xl-2 open_sch_info_${item.sm_IDX}`}
        >
          <div className="row m-0 p-2 p-xl-0">
            <div className="col-6 m-0 p-0 d-flex flex-row">
              <span className="mr-1 mb-0">
                <i className="fa-regular fa-file-lines" />
              </span>
              <div>
                <p>{item.sm_DOC_CLOSE}</p>
                <p>
                  ({sm_DOC_CLOSE_day}) {item.sm_DOC_CLOSE_TIME}
                </p>
              </div>
            </div>
            <div className="col-6 m-0 p-0 d-flex flex-row">
              <span className="font-weight-bold mr-1">
                <i className="fa-solid fa-dolly" />
              </span>
              <div>
                <p>{item.sm_CARGO_CLOSE}</p>
                <p>
                  ({sm_CARGO_CLOSE_day}) {item.sm_CARGO_CLOSE_TIME}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`col-12 col-xl-4 m-0 p-1 p-xl-0 order-4 order-xl-3 open_sch_info_${item.sm_IDX}`}
        >
          <div className="row m-0 p-2 font-weight-bold">
            <div className="col-6 m-0 p-0">
              <p className="text-dark">{item.sm_ORIGIN}</p>
              <p className="text-danger">
                {item.sm_DEPARTURE_DATE} ({sm_DEPARTURE_DATE_day})
              </p>
            </div>
            <div className="col-6 m-0 p-0">
              <p className="text-dark">{item.sm_DEST}</p>
              <p className="text-danger">
                {item.sm_ARRIVE_DATE} ({sm_ARRIVE_DATE_day}){" "}
              </p>
            </div>
          </div>
        </div>
        <div
          className={`col-6 col-xl-1 m-0 px-1 py-2 p-xl-0 order-2 order-xl-4 open_sch_info_${item.sm_IDX}`}
        >
          <div className="h-100 d-flex flex-column justify-content-center">
            <p className="font-weight-bold">{item.sm_VESSEL}</p>
            {item.sm_VOY && <p>{item.sm_VOY}</p>}
          </div>
        </div>
        <div className="col-12 m-0 p-0 order-5 order-xl-5 d-xl-none border-top" />
        <div className="col-12 col-xl-2 order-7 order-xl-6 m-0 p-0">
          <div className="py-1 d-flex flex-row  justify-content-around align-items-center position-relative flex-grow-1">
            <div className="position-relative mr-1 hover_point text-center">
              <span className="text-center p-0 m-0">
                <a
                  className="h5 m-0 p-0 text-decoration-none text-secondary border-0 bg-transparent"
                  data-toggle="collapse"
                  href={`#collapse_${item.sm_IDX}`}
                  role="button"
                  aria-expanded="false"
                  aria-controls={`#collapse_${item.sm_IDX}`}
                  id={`collapse_btn_${item.sm_IDX}`}
                >
                  <i className="fa-regular fa-circle-question" />
                </a>
              </span>

              <div
                className="position-absolute bg-white border shadow-sm p-2 rounded text-center font-weight-bold"
                style={{
                  minWidth: 180,
                  bottom: "calc(100% + 20px)",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 9,
                }}
              >
                {item.sm_PROMO_YN === "Y" && (
                  <p className="text-danger">*{item.sm_PROMO_MEMO}</p>
                )}
                {t("schedule.msg.clickToDetail")}
                <div
                  className="bg-white border-right border-bottom"
                  style={{
                    transform: "rotate(45deg)",
                    marginLeft: -10,
                    width: 20,
                    height: 20,
                    position: "absolute",
                    left: "50%",
                  }}
                />
              </div>
            </div>
            <div
              className="position-relative mr-1 hover_point text-center cursor-pointer"
              onClick={() => {
                insertUserLog(item, "book", 1);
                openCostModal(item);
              }}
            >
              <span className="h5">
                <i
                  className={`fa-solid fa-magnifying-glass mx-1 cursor_pointer `}
                />
              </span>

              <div
                className="position-absolute bg-white border shadow-sm p-2 rounded text-center font-weight-bold"
                style={{
                  minWidth: 180,
                  bottom: "calc(100% + 20px)",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 9,
                  wordBreak: "keep-all",
                }}
              >
                {t("schedule.msg.requestBooking")}
                <div
                  className="bg-white border-right border-bottom"
                  style={{
                    transform: "rotate(45deg)",
                    marginLeft: -10,
                    width: 20,
                    height: 20,
                    position: "absolute",
                    left: "50%",
                  }}
                />
              </div>
            </div>
            <div className="position-relative mr-1 hover_point text-center cursor-pointer">
              <span className="text-center p-0 m-0">
                {item.sm_PROVIDER_ID && (
                  <button
                    className="btn btn-custom-secondary btn-sm  btn-block"
                    style={{ fontSize: "10px", padding: "0.1rem" }}
                    onClick={() => {
                      requestEnquiry(item, 0);
                    }}
                  >
                    {t("schedule.operations")}
                  </button>
                )}
                {item.sm_PROVIDER_SALES_ID && (
                  <button
                    className="btn btn-custom-primary btn-sm  btn-block"
                    style={{
                      fontSize: "10px",
                      padding: "0.1rem",
                      marginTop: "0.1rem",
                    }}
                    onClick={() => {
                      requestEnquiry(item, 1);
                    }}
                  >
                    {t("schedule.sales")}
                  </button>
                )}
              </span>
              <div
                className="position-absolute bg-white border shadow-sm p-2 rounded text-center font-weight-bold"
                style={{
                  minWidth: 180,
                  bottom: "calc(100% + 20px)",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 9,
                }}
              >
                {t("schedule.msg.chatOnLogitalk")}
                <div
                  className="bg-white border-right border-bottom"
                  style={{
                    transform: "rotate(45deg)",
                    marginLeft: -10,
                    width: 20,
                    height: 20,
                    position: "absolute",
                    left: "50%",
                  }}
                />
              </div>
            </div>
            <div
              className="position-relative mr-1 hover_point text-center cursor-pointer"
              onClick={() => {
                insertUserLog(item, "ship", 1);
                if (!isAbleShipTracking) return;
                if (!loginInfo) {
                  codeList.Modal.current.alert(t("schedule.msg.requiresLogin"));
                  return;
                }
                oceanlook.openPopup(item.sm_VESSEL);
              }}
              style={isAbleShipTracking ? { cursor: "pointer" } : {}}
            >
              <span className="text-center p-0 m-0">
                <span className="h5">
                  {isAbleShipTracking ? (
                    <i className="fa-solid fa-location-dot" />
                  ) : (
                    <i
                      className="fa-solid fa-location-dot"
                      style={{ color: "transparent" }}
                    />
                  )}
                </span>
              </span>

              {isAbleShipTracking && (
                <div
                  className="position-absolute bg-white border shadow-sm p-2 rounded text-center font-weight-bold"
                  style={{
                    minWidth: 180,
                    bottom: "calc(100% + 20px)",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 9,
                  }}
                >
                  {t("schedule.msg.tracking")}
                  <div
                    className="bg-white border-right border-bottom"
                    style={{
                      transform: "rotate(45deg)",
                      marginLeft: -10,
                      width: 20,
                      height: 20,
                      position: "absolute",
                      left: "50%",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="collapse col-12 m-0 p-0 order-6 order-xl-7"
          id={`collapse_${item.sm_IDX}`}
        >
          <div className="py-2 px-3" style={{ fontSize: "1em" }}>
            <div className="row m-0 p-0">
              <div className="col-5 col-sm-4 col-xl-2 py-1 px-0 font-weight-bold border-bottom">
                {t("schedule.vessel")}
              </div>
              <div className="col-7 col-sm-8 col-xl-4 py-1 px-0 border-bottom">
                {item.sm_VESSEL} / {item.sm_VOY}
              </div>
              <div className="col-5 col-sm-4 col-xl-2 py-1 px-0 font-weight-bold border-bottom">
                {t("schedule.leadTime")}
              </div>
              <div className="col-7 col-sm-8 col-xl-4 py-1 px-0 border-bottom">
                {(new Date(item.sm_ARRIVE_DATE).getTime() -
                  new Date(item.sm_DEPARTURE_DATE).getTime()) /
                  (1000 * 3600 * 24)}
                {t("schedule.days")}
              </div>
            </div>
            <div className="row m-0 p-0">
              <div className="col-5 col-sm-4 col-xl-2 py-1 px-0 font-weight-bold border-bottom">
                {t("schedule.docClose")}
              </div>
              <div className="col-7 col-sm-8 col-xl-4 py-1 px-0 border-bottom">
                <span>
                  {item.sm_DOC_CLOSE} ({sm_DOC_CLOSE_day})
                </span>
                <span>{" " + item.sm_DOC_CLOSE_TIME}</span>
              </div>
              <div className="col-5 col-sm-4 col-xl-2 py-1 px-0 font-weight-bold border-bottom">
                {t("schedule.cargoClose")}
              </div>
              <div className="col-7 col-sm-8 col-xl-4 py-1 px-0 border-bottom">
                <span>
                  {item.sm_CARGO_CLOSE} ({sm_CARGO_CLOSE_day})
                </span>
                <span>{" " + item.sm_CARGO_CLOSE_TIME}</span>
              </div>
            </div>
            <div className="row m-0 p-0">
              <div className="col-5 col-sm-4 col-xl-2 py-1 px-0 font-weight-bold border-bottom">
                {t("schedule.expectedDeparture")}
              </div>
              <div className="col-7 col-sm-8 col-xl-4 py-1 px-0 border-bottom">
                {item.sm_DEPARTURE_DATE} ({sm_DEPARTURE_DATE_day})
              </div>
              <div className="col-5 col-sm-4 col-xl-2 py-1 px-0 font-weight-bold border-bottom">
                {t("schedule.expectedArrival")}
              </div>
              <div className="col-7 col-sm-8 col-xl-4 py-1 px-0 border-bottom">
                {item.sm_ARRIVE_DATE} ({sm_ARRIVE_DATE_day})
              </div>
            </div>
          </div>
          <div className="rounded col-12 py-2 px-3 flex-column flex-xl-row align-items-xl-center border m-2">
            <div className="font-weight-bold text-freiscop mb-1">
              ※ {t("schedule.importantNotice")}
            </div>
            <p
              className="text-dark"
              dangerouslySetInnerHTML={{ __html: item.sm_REMARK }}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
